/**
 * @author Jafar Amini in March 2018.
 */
export enum TokenMode {
  URL = <any>'URL',
  HEADER = <any> 'HEADER'
}
